import { render, staticRenderFns } from "./EdenFilter.vue?vue&type=template&id=c4a9d890"
import script from "./EdenFilter.vue?vue&type=script&lang=js"
export * from "./EdenFilter.vue?vue&type=script&lang=js"
import style0 from "./EdenFilter.vue?vue&type=style&index=0&id=c4a9d890&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports